import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import "./homepageslider.css";
import { IoMdSearch } from 'react-icons/io';
import AnimatedText from '../animatedText/AnimatedText';
import bgVideo from "../homePageSlider/homepagevideo.mp4";
import bgVideoM from "../homePageSlider/homepagevideomobile.mp4";
import bgVideo2 from "../homePageSlider/homepagevideoblur.mp4";
import TimeCounter from '../TimeCounter/TimeCounter';
import { AiOutlineBarChart } from 'react-icons/ai';
import { LuBrain } from 'react-icons/lu';
import { useLanguage } from '../../context/LanguageContext';


const HomePageSlider = () => {

  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const { t, changeLanguage } = useLanguage();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`home-slider-container flex flex-col items-center justify-center ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div class="video-container homepage-video-web">
        <video class="homepage-video" src={bgVideo} autoPlay muted loop playsInline></video>
      </div>
      <div class="video-container homepage-video-mobile md:hidden">
        <video class="homepage-video" src={bgVideoM} autoPlay muted loop playsInline></video>
      </div>
      <div className="text-center mb-8 flex flex-col items-center z-[2]">
       
        <AnimatedText /> <br />
        {/* <p className='text-xl  font-bold w-[500px]'>Aloha Genius Ai, yalnızca birkaç saniyede ve çok daha düşük bir maliyetle ihtiyaç duyulan sektöre yönelik kullanıcı yardımı sunan bir <span className='text-[#593688] font-extrabold'>Türkçe Büyük Dil Modeli Tabanlı Sohbet Yapay Zeka Sistemi</span>'dir.</p> */}
        {/* <Countdown /> */}
        <span className='text-xl font-bold w-[500px] mt-16 mb-2 countdown-title1'>{t("timecount-title")}</span>
        {/* <CountdownFlip /> */}
        <TimeCounter />
        <Link className="navbar-try-link my-8" to="/contact">{t("info-text1")}</Link>
      </div>

      <div className='home-page-card-container'>

        <div className='home-page-card select-none'>
          <LuBrain className='home-page-card-icon' />
          <span className='text-[22px] font-bold mb-2'>{t("sliderbox1-title")}</span>
          <p className='text-[20px]'>{t("sliderbox1-text")}</p>
        </div>

        <div className='home-page-card select-none'>
          <IoMdSearch className='home-page-card-icon' />
          <span className='text-[22px] font-bold mb-2'>{t("sliderbox2-title")}</span>
          <p className='text-[20px]'>{t("sliderbox2-text")}</p>
        </div>

        <div className='home-page-card select-none'>
          <AiOutlineBarChart className='home-page-card-icon' />
          <span className='text-[22px] font-bold mb-2'>{t("sliderbox3-title")}</span>
          <p className='text-[20px]'>{t("sliderbox3-text")}</p>
        </div>
      </div>


      <div className="speech-bubble bubble1 bubble-animated">
     "{t("bubble1")}"
      </div>
      <div className="speech-bubble bubble2 bubble-animated">
      "{t("bubble2")}"
      </div>
      <div className="speech-bubble bubble3 bubble-animated">
      "{t("bubble3")}"
      </div>
      <div className="speech-bubble bubble4 bubble-animated">
      "{t("bubble4")}"
      </div>

    </div>
  );
};

export default HomePageSlider;
